import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import "./../styles/styles.css"; // Assurez-vous que le style est compatible

function ResetPassword() {
  // Récupérer la location actuelle pour lire les paramètres d'URL
  const location = useLocation();
  const navigate = useNavigate();

  // 1. Récupération du token depuis l'URL (Ex: /reset-password?token=XYZ123)
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');

  // États pour les mots de passe et le feedback utilisateur
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;
  
  // Message à afficher si le token est manquant/invalide côté Front-end
  if (!token) {
    return (
      <div className="login-container">
        <div className="login-card">
          <h2>Erreur de Lien</h2>
          <p className="error-message">Le lien de réinitialisation est invalide ou manquant. Veuillez revenir à la page de mot de passe oublié pour générer un nouveau lien.</p>
          <Link to="/forgot-password" className="login-button" style={{display: 'block', textAlign: 'center', marginTop: '20px'}}>
            Refaire une demande
          </Link>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // 2. Validation Front-end des mots de passe
    if (password.length < 8) {
        setError('Le mot de passe doit contenir au moins 8 caractères.');
        setLoading(false);
        return;
    }
    
    if (password !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas.');
      setLoading(false);
      return;
    }
    
    // 3. Appel API vers reset-password.php
    try {
      const response = await fetch(`${API_URL}/auth/reset-password.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
            token: token, 
            newPassword: password 
        }),
      });

      const data = await response.json();

      if (data.success) {
        // 4. Succès: Redirection
        alert('Votre mot de passe a été réinitialisé avec succès ! Vous pouvez maintenant vous connecter.');
        navigate('/login');
      } else {
        // 4. Échec: Afficher l'erreur du Back-end (token invalide/expiré)
        console.error('Erreur API reset:', data.message);
        setError(data.message || 'Erreur lors de la réinitialisation. Le lien est peut-être expiré.');
      }
    } catch (err) {
      console.error('Erreur réseau/API :', err);
      setError('Impossible de se connecter au serveur. Veuillez réessayer plus tard.');
    } finally {
      setLoading(false);
    }
  };

  // 5. Rendu du formulaire
  return (
    <div className="login-container">
      <div className="login-card">
        <h2>Réinitialiser le mot de passe</h2>
        <p className="login-subtitle">Entrez votre nouveau mot de passe sécurisé.</p>
        <form onSubmit={handleSubmit}>
          
          <div className="input-group">
            <label htmlFor="password">Nouveau mot de passe :</label>
            <input
              type="password"
              id="password"
              placeholder="Minimum 8 caractères"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
              required
            />
          </div>
          
          <div className="input-group">
            <label htmlFor="confirm-password">Confirmer le mot de passe :</label>
            <input
              type="password"
              id="confirm-password"
              placeholder="Confirmer le nouveau mot de passe"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="login-input"
              required
            />
          </div>
          
          {error && <p className="error-message">{error}</p>}
          
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Réinitialisation...' : 'Changer le mot de passe'}
          </button>
        </form>
        <div className="login-links">
            <Link to="/login">Retour à la connexion</Link>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;